import { useTranslation } from "react-i18next";
import { STRINGS } from "../../../constants";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";

const About = ({ data }) => {
  const [videoLink, setVideoLink] = useState("");

  About.propTypes = { data: PropTypes.any };

  const { t } = useTranslation();

  useEffect(() => {
    if (data?.videoLink[0]) {
      const embedUrl =
        data?.videoLink?.length > 1
          ? data?.videoLink[1]?.replace("watch?v=", "embed/")
          : data?.videoLink[0]?.replace("watch?v=", "embed/");
      setVideoLink(embedUrl);
    }
  }, [data]);

  return (
    <>
      <div className="my-2">
        <p className="text-sm">{data?.about}</p>
      </div>

      <div className="my-2">
        <h2 className="text-base font-medium text-[#8A8A8A] mt-2">
          {t(STRINGS.videos)}
        </h2>
        <div className="bg-[#F8F8F8] p-2 rounded-2xl flex items-start justify-start gap-2">
          {videoLink && (
            <iframe
              width="560"
              height="315"
              src={videoLink}
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe>
          )}
        </div>
      </div>
    </>
  );
};

export default About;
